import { useEffect, useState } from "react";
import { Minus, Plus as PlusIcon } from "lucide-react";
import { Container, SiteFooter, SiteHeader } from "./SiteChrome";
import { api } from "../services/apiService";
import { useCmsBatch } from "../hooks/useCmsBatch";

const Plus = ({ open }) => (
  <span className={`plus ${open ? "is-open" : ""}`} aria-hidden="true">
    {open ? <Minus size={18} strokeWidth={1.25} /> : <PlusIcon size={18} strokeWidth={1.25} />}
  </span>
);

export function FaqPage() {
  const [faqs, setFaqs] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [active, setActive] = useState(0);
  const { content } = useCmsBatch(["faq-hero"]);
  const hero = content["faq-hero"] || {};

  useEffect(() => {
    api.get("/faq")
      .then((response) => setFaqs(response.data.faqs || []))
      .catch(() => setFaqs([]))
      .finally(() => setLoaded(true));
  }, []);

  return (
    <>
      <SiteHeader />
      <main>
        <section className="section dark">
          <Container>
            <p className="eyebrow lime"><span>01</span>FAQ</p>
            <h2>{hero.title || "Frequently asked questions."}</h2>

            {!loaded ? null : faqs.length === 0 ? (
              <p style={{ color: "var(--muted)", lineHeight: 1.8, marginTop: 24, maxWidth: 620 }}>
                We're still putting our FAQ together — reach out through our contact page and we'll answer anything you need in the meantime.
              </p>
            ) : (
              <div className="offer-list" style={{ marginTop: 24 }}>
                {faqs.map((faq, index) => (
                  <article className={`offer ${active === index ? "active" : ""}`} key={faq._id}>
                    <button onClick={() => setActive(active === index ? -1 : index)} aria-expanded={active === index}>
                      <span>{faq.category}</span>
                      <h3 style={{ fontSize: 18, textTransform: "none" }}>{faq.question}</h3>
                      <Plus open={active === index} />
                    </button>
                    <div className="offer__body" style={{ gridTemplateColumns: "0 minmax(0, 680px) 1fr", maxHeight: active === index ? 400 : 0 }}>
                      <p style={{ marginBottom: 26 }}>{faq.answer}</p>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </Container>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
